/**
 * 処理後物の種類
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/recycle_disposed_item_subcategories`

const search_after_disposal_item_category = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 処理後物種類リスト
     * @param context
     * @param param1
     * @param param1.disposal_category_codes { String } 大分類コード
     * @return {Promise<unknown>}
     */
    index (context, { disposal_category_codes }) {
      const params = {
        disposal_category_codes: disposal_category_codes,
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default search_after_disposal_item_category
